import connection from "./connection";
import axios from "axios";

export class StatesServices{
  
    URL = connection.DEPLOY_URL + '/states';


    async getAllStates(){
        return await axios.post(this.URL + "/getAllStates")
        .then(res => {
            return res.data
          })
    }
}